<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    ></page-template>
  </div>
</template>
<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';
  import userPower from '@/mixin/userPower'

  export default {
    mixins: [userPower],
    components: {
      pageTemplate
    },
    data() {
      return {
        dialogVisibility: false,
        // 高级搜索条件
        searchOptions: {
          simple: [
            {
              label: "收银员名称",
              type: "input",
              prop: "name",
              ifFuzzy: true,
              placeholder: "请输入收银员名称"
            },
            {
              label: "收银员编码",
              type: "input",
              prop: "storeName",
              ifFuzzy: true,
              placeholder: "请输入收银员编码,支持模糊匹配"
            },
          ],
          complex: [
            {label: "选择日期", prop: "startTime", type: "dateTimeRangeButton", dateType: "datetime", span: 24},
            {
              label: "门店名称",
              type: "select",
              prop: "storeId",
              data: [],
              span:12,
              url: api.system.seStore
            },
            {
              label: '收银员',
              type: 'select',
              prop: 'supplierId',
              data: [],
              span: 12,
              url: api.system.account,
              param:{type:40}
            },
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: "查询",
          },
          {
            label: "打印",
          },
          {
            label: "导出",
          },
        ],
        // 表格信息配置
        tableOptions: {
          indexShow: true,//是否显示索引
          columns: [
            {label: "门店名称", prop: "name", width: "120", align: "center"},
            {
              label: "门店编码",
              prop: "loginName",
              width: "120",
              align: "center"
            },
            {
              label: '收银员编号',
              prop: 'storeName',
              width: '150',
              align: 'center'
            },
            {label: "收银员姓名", prop: "name", width: "120", align: "center"},
            {
              label: '首笔交易时间',
              prop: 'commissionRate',
              width: '150',
              align: 'center'
            },
            {
              label: "末笔交易时间",
              prop: "status",
              width: "120",
              align: "center",
              enumData: this.$utils.getCacheStatus('sysUser.status')
            },
            {
              label: "交易金额",
              prop: "status",
              width: "120",
              align: "center",
              enumData: this.$utils.getCacheStatus('sysUser.status')
            },
            {
              label: "现金缴款金额",
              prop: "status",
              width: "120",
              align: "center",
              enumData: this.$utils.getCacheStatus('sysUser.status')
            },
            {
              label: "备注",
              prop: "status",
              width: "120",
              align: "center",
              enumData: this.$utils.getCacheStatus('sysUser.status')
            },
          ],
          url: api.system.account
        },
      };
    },
    created() {
    this.setStore(this.searchOptions.complex);
  },
    methods: {}
  };
</script>




// WEBPACK FOOTER //
// src/page/retail/query/demand/Note.vue